import { SwiperSlide } from "swiper/react";

import Header from "../../components/Header";
import Slider from "../../components/Slider";
import Breadcrumbs from "../../components/Breadcrumbs";
import Footer from "../../components/Footer";
import SEO from "../../components/SEO";
import SwiperSlider from "../SwiperSlider";
import CarouselData from "../../variables/variables.json";
import Carousel from "../Carousel";
import Banner from "../Banner";

export default function SectionLayout(props) {
	const Miasto = props.miasto;
	const Podatek = props.podatek;
	const Hero = props.typeHero;

	return (
		<>
			{/* HEAD */}
			<SEO
				miasto={Miasto}
				podatek={Podatek}
				blog={props.blog}
				seoTitle={props.seoTitle}
				seoDescription={props.seoDescription}
				canonical={props.canonical}
				routerRedirect={props.routerRedirect}
				imagesUrl={props.imagesUrl}
				author={props.author}
				datePublication={props.datePublication}
				hours={props.hours}
			/>


			{/* TOP */}
			<Header miasto={Miasto} />

			{Hero === "slider" && (
				<Slider
					miasto={Miasto}
					podatek={Podatek}
					small
					blog={props.blog}
					title={props.title}
					description={props.description}
				/>
			)}

			{Hero === "carousel" && (
				<SwiperSlider miasto={Miasto} podatek={Podatek}>
					{CarouselData.miasta[Miasto].carousel[Podatek].map((carousel, index) => (
						<SwiperSlide key={index}>
							<Carousel
								miasto={Miasto}
								podatek={Podatek}
								small
								slider
								index={index}
								tagTitle={carousel.header.tag.title}
							/>
						</SwiperSlide>
					))}
				</SwiperSlider>
			)}

			{Hero === "banner" && (
				<Banner
					miasto={Miasto}
					podatek={Podatek}
					author={props.author}
					small
					title={props.title}
					description={props.description}
				/>
			)}

			{Hero === "none" && (
				<div>
					<p>Brak banneru</p>
				</div>
			)}

			<Breadcrumbs miasto={Miasto} layout={props.breadcrumbsLayout} />

			{/* SECTION */}
			{props.children}

			{/* BOTTOM */}
			<Footer miasto={Miasto} />
		</>
	);
}
